import React, {ReactNode} from 'react';
import image from 'assets/img/landing.webp';
import './style.scss'

type Props = {
  topContent: ReactNode,
  children: ReactNode[],
  className?: string,
  limitedWidth?: boolean
  pageContentClassName?: string
  hideImage?: boolean
}

const EntryView = ({ topContent, children, className, limitedWidth, pageContentClassName, hideImage }: Props) => {
  hideImage = !!hideImage
  limitedWidth = limitedWidth ?? true

  className = 'page' + (className ? ` ${className}` : '')
  pageContentClassName = 'page-content safe-area-bottom side-by-side' + (pageContentClassName ? ` ${pageContentClassName}` : '')

  return (
    <div className={className}>
      {topContent}
      <div className={pageContentClassName}>
        { !hideImage && <div className="image" style={{backgroundImage: "url(" + image + ")"}}/> }
        <div className="actions">
          {limitedWidth ? <div className="limited-width">{children}</div> : children}
        </div>
      </div>
    </div>
  );
}

export default EntryView;
